import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minutesToHm'
})
export class MinutesToHmPipe implements PipeTransform {
  transform(minutes: string | undefined): string {
    if (minutes === undefined || minutes === '') {
      return '0m';
    }

    const numericMinutes = Number(minutes);

    if (isNaN(numericMinutes) || numericMinutes < 0) {
      return '0m';
    }

    const totalMinutes = Math.floor(numericMinutes);
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;

    let result = '';
    
    if (hours > 0) {
      result += `${hours}h`;
    }

   
    if (hours > 0) {
      result += ` ${remainingMinutes}m`;
    } else {
      result = `${remainingMinutes}m`;
    }

    return result;
  }
}